import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createClass from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import editorStyle from '../util/defaultStyle';
import Item from '@antv/g6/lib/item/item';
import { deepMix } from '@antv/util';
var ControlPoint = /*#__PURE__*/function (_Item) {
  _inherits(ControlPoint, _Item);
  var _super = _createSuper(ControlPoint);
  function ControlPoint(cfg) {
    var _this;
    _classCallCheck(this, ControlPoint);
    _this = _super.call(this, deepMix(cfg, {
      type: 'controlPoint',
      isActived: false,
      model: {
        type: 'controlPoint',
        style: _objectSpread({}, editorStyle.anchorPointStyle)
      }
    }));
    _this.enableCapture(true);
    _this.toFront();
    return _this;
  }
  return _createClass(ControlPoint);
}(Item);
export { ControlPoint as default };